import React from "react";

const InputField = ({ error, input, onChange = () => {} }) => {
  const isCheckbox = input.type === "checkbox";

  return (
    <div className={`${isCheckbox ? "flex items-center gap-2" : ""} w-full`}>
      <label
        htmlFor={input.id}
        className={`block text-sm font-medium ${!isCheckbox ? "mb-1.5" : ""}`}
        style={{ color: '#1e293b' }}
      >
        {input.label}
        {input.required && <span className="text-red-500 ml-0.5">*</span>}
      </label>
      <input
        id={input.id}
        value={input.value}
        name={input.name}
        type={input.type}
        onChange={onChange}
        className={`
          ${!isCheckbox ? "w-full" : ""}
          px-3 py-2.5 text-sm rounded-lg
          bg-white text-slate-900
          border border-slate-300
          focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500
          placeholder:text-slate-400
          transition-colors duration-150
          ${error ? "border-red-500 focus:ring-red-500/20 focus:border-red-500" : ""}
        `}
        placeholder={input.placeholder}
      />
      {error && (
        <p className="mt-1 text-xs text-red-600">{error}</p>
      )}
    </div>
  );
};

export default InputField;
